import axios from 'axios'
import store from '@/store'
import securityApi from '@/api/security'
import auth from '@/auth/auth.js'

axios.defaults.baseURL = process.env.VUE_APP_AXIOS_URL
axios.defaults.headers["Authorization"] = `Bearer ${localStorage.token}`
axios.defaults.headers["session_id"] = localStorage.sessionId
axios.defaults.headers["source"] = "Customer";
 
axios.interceptors.request.use(function (config) {
    //reset login timer on every API call
    store.commit('setLoginStartTime', Date())
    store.commit('setLoginTimer', Date())

    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(async function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
}, async function(error) {
    if (error.toString().toLowerCase().includes('network')) {
        throw error
    }
    if (error.toString().includes('ERR_CONNECTION_REFUSED')) {
        throw error
    }
    
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    const originalRequest = error.config
    if (error.response.status == 401) {

        //handle invalid credentials from login api
        if (error.config.url.includes('login')) {
            throw error
        }

        //check if this code execution if returned by refresh-token api or coming from login
        if (error.config.url.includes('refresh-token')) {
            //expired refresh token
            const logoutData = {
                userId: store.state.userId,
                logoutCode: "expired_token",
                logoutMessage: "Expired Refresh Token",
            }
            auth.logout(logoutData)
            return Promise.reject(error)
        }

        // session_id is invalid or missing
        if (error.response.data === 'invalid-session-id') {
            const logoutData = {
                userId: store.state.userId,
                logoutCode: "invalid-session-id",
                logoutMessage: "Your session has expired or is invalid. Please login again.",
            }
            auth.logout(logoutData)
            return Promise.reject(error)
        }
        
        //expired token handling
        if (error.response.headers['token-expired']) {
            var data = {
                token: localStorage.token,
                refreshToken: localStorage.refreshToken,
                sourceType: 'Customer'
            }
            
            //note if refreshToken returns 401, error will be capture again on the async function(error)
            const response = await securityApi.refreshToken(data) 
            if (response.status == 200) {
                originalRequest._retry = true;
    
                axios.defaults.headers["Authorization"] = `Bearer ${response.data.token}`
                localStorage.token = response.data.token
                localStorage.refreshToken = response.data.refreshToken
    
                originalRequest.headers['Authorization'] = `Bearer ${response.data.token}`

                return axios.request(originalRequest)
            }
        }
    } else {
        //handles other error such as 403, etc
        return Promise.reject(error)
    }
});